import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import { IFilter } from "../../../../types/filter.type";
import FilterText from "../FilterText";

function FilterCRHoatchat({ filter, setFilter, load }: IFilter) {
  const defaultFilter = {
    hoatchat: "",
  };

  useEffect(() => {
    setFilter(defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Stack sx={{ width: "100%" }} gap={2}>
      <FilterText
        label="Tên hoạt chất"
        placeholder="Tìm theo tên hoạt chất"
        defaultValue={filter.hoatchat}
        onChange={(val) => setFilter({ ...filter, hoatchat: val })}
      />
    </Stack>
  );
}

export default FilterCRHoatchat;
